import { Form, Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { connect } from "react-redux";

import { SidebarToggleIcon } from "../../../../assets/icons/iconsProvider";
import {
  EMPTY_STRING,
  INVENTORY_MODAL_TYPES,
  SALE_TRANSACTION_ACTIVITY_TYPES,
  SHOPIFY_STATUS_OPTIONS,
  TRADE_PRODUCT_DEFAULT_DATA_OBJECT,
  buttonNameConstants,
  buttonTypeConstants,
  inventoryConstants,
  toastMessages,
  toastType,
  toggleSwitchButtonConstants,
  transactionConstants,
  preserveMode,
} from "../../../../constants";
import {
  inventoryActions,
  shopifyActions,
  systemActions,
} from "../../../../redux/actions";
import {
  AddEditInventoryModalPricesHistoryStats,
  AddInventoryProductPrices,
  Button,
  CheckboxField,
  ProductModalHeader,
  ProductTagList,
} from "../../../../shared/components";
import {
  calculateOfferPrices,
  changePriceBaseOnTags,
  customToast,
  findInventoryProductDetail,
  formatDate,
  getAddInventoryPartialInitialValues,
  getAddInventoryPricePayloadObject,
  getAddInventoryRootPayloadPartialObject,
  getInventoryInitialValueType,
  getMarginDropdownValue,
  getPresetStockPrice,
  getProductSubCategory,
  handleBeautifyMarketPrice,
  handleCashOfferValues,
  handleConditionChange,
  handleMarginChange,
  handleMaxInventoryCount,
  handleProductConditionUpdate,
  handleTradeOfferValues,
  isProductsExistInStock,
  isSerialNumberUnique,
  isSystemProduct,
  isTransactionAllowed,
  parseToDecimalNumber,
  updatePreserveState,
  updateProductImageUrl,
} from "../../../../shared/utility";
import { addNewTradeValidationSchema } from "../../../../shared/validationSchema/validationSchema";
import {
  PRODUCT_CONDITIONS_ENUMS,
  PRODUCT_TYPES_ENUMS,
  TRADING_CARD_CATEGORIES_ENUMS,
} from "../../../../system/globalEnums";
import SearchInventory from "../../../Inventory/Items/SearchInventory/SearchInventory";

const AddTrade = (props) => {
  //-------Destructure props
  const {
    user,
    outlet,
    addToCart,
    customTypes,
    productTags,
    currentStore,
    newTradeData,
    tradeinMargin,
    productToEdit,
    addTradeModal,
    markupPresets,
    toggleAddModal,
    activateSpinner,
    shopifySettings,
    handleTradeData,
    customCategories,
    deactivateSpinner,
    inventoryProducts,
    toggleAddTradeModal,
    productShopifySettings,
    getShopifyMappingsById,
    addTradeBatchInventory,
    priceChartingProductInfo,
    setProductShopifySettings,
    setPriceChartingProductInfo,
    getInventoryByPricechartingId,
    emptyPriceChartingProductObject,
    modalType = INVENTORY_MODAL_TYPES.ADD_FROM_NEW_TRADE_SEARCH,
  } = props;
  const [isFirstRender, setIsFirstRender] = useState(true);
  const isProductEditAndFirstRender =
    productToEdit &&
    typeof productToEdit === "object" &&
    productToEdit.hasOwnProperty("id") &&
    (productToEdit.id !== null || productToEdit.id !== undefined) &&
    isFirstRender;
  const isEditModal =
    modalType === INVENTORY_MODAL_TYPES.EDIT_FROM_ADD_TRADE_CART ||
    modalType === INVENTORY_MODAL_TYPES.EDIT_FROM_ADD_BATCH_TRADE_MODAL;
  const asyncSelectRef = useRef();
  const hiddenFileInput = useRef(null);
  const [productUrl, setProductUrl] = useState("");
  const [initialRatio, setInitialRatio] = useState("");
  const [selectedTags, setSelectedTags] = useState(
    isProductEditAndFirstRender ? productToEdit?.tags : []
  );
  const [conditionList, setConditionList] = useState([]);
  const [cashOfferValue, setCashOfferValue] = useState("");
  const [productCondition, setProductCondition] = useState();
  const [productTagsList, setProductTagsList] = useState([]);
  const [isInStoreQuantity, setIsInStoreQuantity] = useState(false);
  const [tradeOfferValue, setTradeOfferValue] = useState("");
  const [productType, setProductType] = useState(PRODUCT_TYPES_ENUMS.ALL);
  //productDataObject will always should be more updated compared to priceChartingProductInfo.productMetaData
  const [productDataObject, setProductDataObject] = useState(
    TRADE_PRODUCT_DEFAULT_DATA_OBJECT
  );
  const [marginTypeObject, setMarginTypeObject] = useState(
    isProductEditAndFirstRender
      ? productToEdit?.tradeProductMetaData?.tradeInMarginTypeObject
      : ""
  );
  const formikRef = useRef();

  const preserveStateRef = useRef({
    mode: preserveMode.PARTIAL,
    hasInteracted: false,
  });
  //-------initial values
  const initialValues = {
    box:
      productCondition?.value === PRODUCT_CONDITIONS_ENUMS.COMPLETE &&
      selectedTags?.includes(inventoryConstants.PRODUCT_TAGS.WITH_BOX)
        ? true
        : false,
    manual:
      productCondition?.value === PRODUCT_CONDITIONS_ENUMS.COMPLETE
        ? selectedTags?.includes(inventoryConstants.PRODUCT_TAGS.MISSING_MANUAL)
          ? false
          : true
        : productCondition?.value === PRODUCT_CONDITIONS_ENUMS.LOOSE
        ? selectedTags?.includes(inventoryConstants.PRODUCT_TAGS.WITH_MANUAL)
          ? true
          : false
        : false,
    cables:
      productCondition?.value === PRODUCT_CONDITIONS_ENUMS.COMPLETE ||
      productCondition?.value === PRODUCT_CONDITIONS_ENUMS.LOOSE
        ? selectedTags?.includes(inventoryConstants.PRODUCT_TAGS.MISSING_WIRES)
          ? false
          : true
        : false,
    controller:
      productCondition?.value === PRODUCT_CONDITIONS_ENUMS.COMPLETE ||
      productCondition?.value === PRODUCT_CONDITIONS_ENUMS.LOOSE
        ? selectedTags?.includes(
            inventoryConstants.PRODUCT_TAGS.MISSING_CONTROLLER
          )
          ? false
          : true
        : false,
    costOfGoods: productDataObject.costOfGoods || EMPTY_STRING,
    ...getAddInventoryPartialInitialValues(
      {
        ...productDataObject,
        ...(isProductEditAndFirstRender ? productToEdit : {}),
        cashOffer: cashOfferValue,
        tradeOffer: tradeOfferValue,
        onlineCashOffer: cashOfferValue,
        onlineTradeOffer: tradeOfferValue,
        onlineUnitSellPrice: isProductEditAndFirstRender
          ? productToEdit.onlineUnitSellPrice
          : productDataObject.onlineUnitSellPrice ||
            productDataObject.inStockPrice,
        inStockPrice: isProductEditAndFirstRender
          ? productToEdit.inStockPrice
          : productDataObject.price?.unit_sell_price ||
            productDataObject.inStockPrice,
      },
      getInventoryInitialValueType(modalType),
      formikRef,
      preserveStateRef.current
    ),
  };
  //------- toggle InStore Quantity
  const toggleIsInStoreQuantity = () => {
    setIsInStoreQuantity((prev) => !prev);
  };

  //-------Change Logo image button
  const handleReplaceButtonClick = () => {
    hiddenFileInput.current.click();
  };

  //-------onselectedtagchange
  // PARTIAL preserve: tag change recalcs pricing, but keep user-entered trade offers
  const onSelectTagsChange = (selectedTags) => {
    preserveStateRef.current.hasInteracted = true;
    preserveStateRef.current.mode = preserveMode.PARTIAL;
    const selectedTagList = selectedTags.map((tag) => tag.label);
    changePriceBaseOnTags(
      selectedTagList,
      productDataObject,
      setProductDataObject,
      priceChartingProductInfo,
      inventoryConstants,
      PRODUCT_CONDITIONS_ENUMS,
      TRADING_CARD_CATEGORIES_ENUMS,
      productCondition,
      productType
    );
    setSelectedTags(selectedTagList);
  };

  //-------handle inventory submit
  const handleAddTradeSubmit = async (values) => {
    //------- check session is open or not also in use or not or outlet is configured or not
    if (isTransactionAllowed(outlet, user, currentStore)) {
      return;
    } else if (handleMaxInventoryCount(newTradeData?.inventory, !isEditModal)) {
      return customToast(
        inventoryConstants.MAX_INVENTORY_COUNT_ERROR,
        toastType.ERROR
      );
    }

    const batchProducts = addTradeBatchInventory?.filter(
      (product) => product?.productId === productDataObject?.productId
    );

    const cartProducts =
      newTradeData?.inventory?.filter(
        (product) => product?.product_id === productDataObject?.productId
      ) || [];

    if (!productDataObject?.productName) {
      customToast("Please select some product", toastType.ERROR);
    } else if (
      (modalType === INVENTORY_MODAL_TYPES.ADD_FROM_NEW_TRADE_SEARCH ||
        (modalType !== INVENTORY_MODAL_TYPES.ADD_FROM_NEW_TRADE_SEARCH &&
          productToEdit.serialNumber !== values.serialNumber)) &&
      isSystemProduct(getProductSubCategory(productDataObject?.genre)) &&
      !isSerialNumberUnique(values.serialNumber, [
        ...(inventoryProducts || []),
        ...(batchProducts || []),
        ...(cartProducts || []),
      ])
    ) {
      customToast(
        toastMessages.PRODUCT_SERIAL_NUMBER_SHOULD_BE_UNIQUE,
        toastType.ERROR
      );
      return;
    } else if (
      values?.serialNumber &&
      (values.isSeparateQuantity
        ? values.onlineQuantity > 1
        : values.quantity > 1)
    ) {
      customToast(toastMessages.SYSTEM_QUANTITY_MUST_BE_1, toastType.ERROR);
      return;
    } else {
      const skuNumber = [transactionConstants.AUTO_GENERATED];
      let dataToAdd = {
        ...getAddInventoryRootPayloadPartialObject({
          ...productDataObject,
          productType: productType,
          ...values,
          cardRarity: productDataObject.cardRarity,
          shopifySettingId: productShopifySettings?.marginType?.isDefault
            ? productDataObject.shopifySettingId
            : productShopifySettings?.marginObject?.id || EMPTY_STRING,
        }),
        sku: skuNumber,
        description: "",
        ratio: initialRatio,
        trackQuantity: true,
        upc: productDataObject.upc,
        cashOffer: values.isSeparateQuantity
          ? values.onlineCashOffer
          : values.cashOffer,
        epid: productDataObject.epid,
        tradeOffer: values.isSeparateQuantity
          ? values.onlineTradeOffer
          : values.tradeOffer,
        genre: productDataObject.genre,
        imgUrl: productDataObject?.imgUrl,
        date_added: formatDate(new Date()),
        tags: selectedTags?.map((tag) => tag),
        product_id: productDataObject.productId,
        additionalCheckList: ["box", "ma11nual"],
        product_name: productDataObject.productName,
        tcgPlayerUrl: productDataObject.tcgPlayerUrl,
        category_name: productDataObject.consoleName,
        apiSource: priceChartingProductInfo?.productMetaData?.sourceApi,
        isSeparateQuantity: values.isSeparateQuantity,
        store: {
          id: currentStore?.id,
          name: currentStore?.storeName,
        },
        price: getAddInventoryPricePayloadObject({
          ...values,
          type: productCondition?.value,
          onlineUnitPurchasePrice: values?.costOfGoods || 0,
          marketPrice: handleBeautifyMarketPrice(productDataObject),
          isSeparateQuantity: values.isSeparateQuantity,
        }),
        tradeProductMetaData: {
          tradeProductType: transactionConstants.PRICECHARTING_PRODUCT,
          isItemLocked: false,
          cashPercentagePerItem: 0,
          tradePercentagePerItem: 0,
          tradeInMarginTypeObject: marginTypeObject,
        },
        isLinkToShopify: productDataObject.isLinkToShopify,
      };

      //------Keep an initial State of the Item
      dataToAdd = {
        ...dataToAdd,
        productInitialState: dataToAdd,
      };

      if (modalType === INVENTORY_MODAL_TYPES.EDIT_FROM_ADD_BATCH_TRADE_MODAL) {
        handleTradeData({
          ...newTradeData,
          inventory: [
            {
              ...productToEdit,
              ...dataToAdd,
              productInitialState: productToEdit.productInitialState,
            },
          ],
        });
      } else if (modalType === INVENTORY_MODAL_TYPES.EDIT_FROM_ADD_TRADE_CART) {
        handleTradeData({
          ...newTradeData,
          inventory: newTradeData.inventory.map((item) => {
            return item.id === productToEdit.id
              ? {
                  ...productToEdit,
                  ...dataToAdd,
                  productInitialState: productToEdit.productInitialState,
                }
              : item;
          }, SALE_TRANSACTION_ACTIVITY_TYPES.ADD_ITEM),
        });
      } else {
        addToCart(dataToAdd);
      }
    }
    toggleAddTradeModal();
    toggleAddModal(false);
    clearAddInventoryForm();
  };

  useEffect(() => {
    const marketPrice = handleBeautifyMarketPrice(productDataObject);
    if (marketPrice === 0) {
      const ratio =
        marginTypeObject?.marginObject?.tradeinMarginPercentage /
        marginTypeObject?.marginObject?.cashMarginPercentage;
      setInitialRatio(ratio);
    } else {
      const initialCashValue =
        marketPrice *
        (marginTypeObject?.marginObject?.cashMarginPercentage / 100);
      const initialTradeValue =
        marketPrice *
        (marginTypeObject?.marginObject?.tradeinMarginPercentage / 100);
      const initialRatio = initialTradeValue / initialCashValue || 0;
      setInitialRatio(initialRatio);
    }
    // eslint-disable-next-line
  }, [marginTypeObject]);

  //-------hide modal
  const handleHideModal = () => {
    toggleAddTradeModal();
    toggleAddModal(false);
    clearAddInventoryForm();
    setProductShopifySettings({});
  };

  //-------empty product data object
  const emptyProductDataObject = () => {
    setProductDataObject({
      productId: EMPTY_STRING,
      productName: EMPTY_STRING,
      consoleName: EMPTY_STRING,
      marketPrice: 0,
      suggestedSellPrice: 0,
      costOfGoods: 0,
      inStorePrice: 0,
      inStockPrice: 0,
      inStockQuantity: 0,
      skuNumber: 0,
      gameStopBuyPrice: 0,
      genre: EMPTY_STRING,
      upc: EMPTY_STRING,
      averageBuyPrice: 0,
      averageSellPrice: 0,
      maxBuyPrice: 0,
      cardNumber: 0,
      tcgPlayerUrl: EMPTY_STRING,
      imgUrl: EMPTY_STRING,
      totalUnitsSold: 0,
      epid: EMPTY_STRING,
    });
  };

  //-------clear form
  const clearAddInventoryForm = () => {
    emptyPriceChartingProductObject();
    emptyProductDataObject();
    setSelectedTags([]);
    setProductType(PRODUCT_TYPES_ENUMS.ALL);
    setProductCondition("");
    setConditionList([]);
    setProductTagsList([]);
    setProductUrl("");
    // Reset preserve state to PARTIAL/false: clear form interaction tracking
    preserveStateRef.current.mode = preserveMode.PARTIAL;
    preserveStateRef.current.hasInteracted = false;
  };

  // Shopify operation: ALL preserve mode to keep all form state during backend operations
  const handleCustomShopifyStatusChange = () => {
    updatePreserveState(preserveStateRef, preserveMode.ALL, true);
  };

  //-------update product condition and type
  useEffect(() => {
    handleProductConditionUpdate(
      currentStore,
      priceChartingProductInfo,
      getInventoryByPricechartingId,
      setProductType,
      setProductUrl,
      productDataObject,
      setProductDataObject,
      productTags,
      setProductTagsList,
      () => {},
      () => {},
      setConditionList,
      setProductCondition,
      false,
      isProductEditAndFirstRender,
      productToEdit
    );
    setProductUrl(""); // eslint-disable-next-line
  }, [priceChartingProductInfo.productObject]);

  //-------Handle Shopfiy In-Store & Online Quantity Check Change
  const handleStoreAndOnlineQuantityChange = (
    value,
    setFieldValue = () => {}
  ) => {
    setProductDataObject((prevState) => ({
      ...prevState,
      isOnlineQuantity: value,
    }));
    setFieldValue("isOnlineQuantity", value);
  };

  useEffect(() => {
    if (
      productCondition?.value &&
      priceChartingProductInfo?.productMetaData?.sourceApi ===
        inventoryConstants.PRICECHARTING_API
    ) {
      findInventoryProductDetail(
        currentStore,
        productCondition?.value,
        productType,
        markupPresets,
        tradeinMargin,
        selectedTags,
        productDataObject.cardRarity,
        productDataObject,
        inventoryProducts,
        setProductDataObject,
        priceChartingProductInfo,
        setPriceChartingProductInfo,
        isProductEditAndFirstRender ? productToEdit : null,
        {
          shopifySettings,
          getShopifyMappingsById,
          productShopifySettings,
          setProductShopifySettings,
        },
        modalType
      );
    } else if (
      priceChartingProductInfo?.productMetaData?.apiSource ===
        inventoryConstants.TCG_PLAYER_API &&
      priceChartingProductInfo?.productMetaData?.condition?.value
    ) {
      findInventoryProductDetail(
        currentStore,
        priceChartingProductInfo?.productMetaData?.condition?.value,
        productType,
        markupPresets,
        tradeinMargin,
        selectedTags,
        productDataObject.cardRarity,
        productDataObject,
        inventoryProducts,
        setProductDataObject,
        priceChartingProductInfo,
        setPriceChartingProductInfo,
        isProductEditAndFirstRender ? productToEdit : null,
        {
          shopifySettings,
          getShopifyMappingsById,
          productShopifySettings,
          setProductShopifySettings,
        },
        modalType
      );
    }

    updateProductImageUrl({
      productType,
      productCondition,
      selectedTags,
      inventoryProducts,
      priceChartingProductInfo,
      setProductDataObject,
      cardRarity: priceChartingProductInfo?.productMetaData?.cardRarity,
    });
    // eslint-disable-next-line
  }, [inventoryProducts, shopifySettings]);

  useEffect(() => {
    if (productCondition?.value) {
      findInventoryProductDetail(
        currentStore,
        productCondition?.value,
        productType,
        markupPresets,
        tradeinMargin,
        selectedTags,
        productDataObject.cardRarity,
        productDataObject,
        inventoryProducts,
        setProductDataObject,
        priceChartingProductInfo,
        setPriceChartingProductInfo,
        isProductEditAndFirstRender ? productToEdit : null,
        {
          shopifySettings,
          getShopifyMappingsById,
          productShopifySettings,
          setProductShopifySettings,
        },
        modalType
      );
    }
    // eslint-disable-next-line
  }, [
    addTradeModal,
    selectedTags,
    productType,
    productCondition,
    shopifySettings,
    priceChartingProductInfo?.productMetaData?.language,
    priceChartingProductInfo?.productMetaData?.grade,
    priceChartingProductInfo?.productMetaData?.cardRarity,
  ]);

  useEffect(() => {
    const marketPrice = handleBeautifyMarketPrice(productDataObject);
    var marginDropDownObject = getMarginDropdownValue(
      marketPrice,
      tradeinMargin,
      productType,
      {
        ...productDataObject,
        tags: selectedTags,
        condition: productCondition?.value,
        cardRarity: productDataObject?.cardRarity || EMPTY_STRING,
        subcategory: getProductSubCategory(productDataObject.genre),
      }
    );
    setMarginTypeObject(
      isProductEditAndFirstRender
        ? productToEdit?.tradeProductMetaData?.tradeInMarginTypeObject
        : marginDropDownObject
    );

    if (inventoryProducts?.length > 0) {
      isProductsExistInStock(
        productCondition?.value,
        selectedTags,
        priceChartingProductInfo?.productMetaData?.cardRarity,
        inventoryProducts,
        priceChartingProductInfo
      );
    }

    // const marketPriceAfterPreset =
    //   getPresetStockPrice(
    //     productType,
    //     marketPrice,
    //     markupPresets,
    //     productDataObject
    //   ) || 0;

    const { cashOffer, tradeOffer } = calculateOfferPrices(
      marketPrice,
      marginDropDownObject?.marginObject,
      marginDropDownObject?.marginObject?.cashMarginPercentage,
      marginDropDownObject?.marginObject?.tradeinMarginPercentage,
      {
        currentStore,
        isCalculateMarketPrice: true,
        product: {
          ...productDataObject,
          productType,
          marketPrice,
        },
        isCalculateInStockPrice: false,
        markupPresets,
      }
    );

    setTradeOfferValue(
      isProductEditAndFirstRender
        ? productToEdit?.tradeOffer
        : parseToDecimalNumber(tradeOffer)
    );
    setCashOfferValue(
      isProductEditAndFirstRender
        ? productToEdit?.cashOffer
        : parseToDecimalNumber(cashOffer)
    );
    // eslint-disable-next-line
  }, [productDataObject]);

  return (
    <Modal
      show={addTradeModal}
      size="xl"
      onHide={handleHideModal}
      animation={true}
      centered
      backdrop="static"
      className={`add-inventory-modal ${productUrl ? "iframe-opened" : ""}`}
    >
      <Formik
        innerRef={formikRef}
        initialValues={initialValues}
        enableReinitialize
        onSubmit={handleAddTradeSubmit}
        validate={(values) =>
          addNewTradeValidationSchema(
            values,
            currentStore?.[
              toggleSwitchButtonConstants.IS_SERIAL_NUMBER_REQUIRED_INVENTORY
            ] &&
              getProductSubCategory(productDataObject?.genre) ===
                TRADING_CARD_CATEGORIES_ENUMS.SYSTEM
          )
        }
      >
        {({ values, setFieldValue }) => (
          <Form>
            <Modal.Header
              closeButton
              className="add-inventory-modal-header pt-0 pb-1"
            >
              <Modal.Title className="w-100 h6">
                <span className="add-inventory-modal-header-name">
                  <div className="w-100 d-flex align-items-center gap-2">
                    <span className="add-inventory-modal-header-name">
                      {modalType ===
                      INVENTORY_MODAL_TYPES.ADD_FROM_NEW_TRADE_SEARCH
                        ? "Add Trade-In"
                        : "Edit Trade-In Item"}
                    </span>
                    {modalType ===
                      INVENTORY_MODAL_TYPES.ADD_FROM_NEW_TRADE_SEARCH && (
                      <Row className="w-100">
                        <Col md={12} className="ps-md-0 pe-5">
                          <SearchInventory
                            customTypes={customTypes}
                            isSearchCustomProduct={true}
                            asyncSelectRef={asyncSelectRef}
                            customCategories={customCategories}
                            onSearchItemSelect={() => {
                              // New search: NONE mode (full reset)
                              preserveStateRef.current.hasInteracted = false;
                              preserveStateRef.current.mode = preserveMode.NONE;
                              setSelectedTags([]);
                            }}
                          />
                        </Col>
                      </Row>
                    )}
                  </div>
                </span>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="add-inventory-modal-body pt-0 d-flex ">
              <Row className={`m-0 ${productUrl ? "w-50" : "w-100"}`}>
                {/* {!isProductEdit && (
                  <Col md={12} className=" ps-md-0">
                    <SearchInventory
                      customTypes={customTypes}
                      asyncSelectRef={asyncSelectRef}
                      customCategories={customCategories}
                    />
                  </Col>
                )} */}
                <Col xs={12} className="add-inventory-hero-wrapper px-0  mt-2">
                  <Row className="m-0">
                    {/* Product image, meta data and Open Iframe Buttons */}
                    <ProductModalHeader
                      values={values}
                      productTags={productTags}
                      selectedTags={selectedTags}
                      setProductUrl={setProductUrl}
                      activateSpinner={activateSpinner}
                      hiddenFileInput={hiddenFileInput}
                      productDataObject={productDataObject}
                      deactivateSpinner={deactivateSpinner}
                      setProductDataObject={setProductDataObject}
                      handleReplaceButtonClick={handleReplaceButtonClick}
                      priceChartingProductInfo={priceChartingProductInfo}
                      conditionList={conditionList}
                      handleConditionChange={(selectedOption) =>
                        handleConditionChange(
                          selectedOption,
                          setProductCondition,
                          priceChartingProductInfo,
                          productTags,
                          setProductTagsList,
                          setProductDataObject,
                          productDataObject,
                          setSelectedTags,
                          setPriceChartingProductInfo,
                          preserveStateRef,
                          preserveMode
                        )
                      }
                      setProductTagsList={setProductTagsList}
                      setSelectedTags={setSelectedTags}
                      setFieldValue={setFieldValue}
                      setConditionList={setConditionList}
                      productCondition={productCondition}
                      setProductCondition={setProductCondition}
                      setPriceChartingProductInfo={setPriceChartingProductInfo}
                      setIsFirstRender={setIsFirstRender}
                    />
                    {productCondition?.value ===
                      PRODUCT_CONDITIONS_ENUMS.COMPLETE ||
                    productCondition?.value ===
                      PRODUCT_CONDITIONS_ENUMS.LOOSE ? (
                      <Col
                        md={12}
                        className="d-flex align-items-center gap-3 my-2"
                      >
                        {productDataObject.genre ===
                        TRADING_CARD_CATEGORIES_ENUMS.SYSTEM ? (
                          productCondition?.value ===
                          PRODUCT_CONDITIONS_ENUMS.COMPLETE ? (
                            <>
                              <CheckboxField name="manual" label="Manual" />
                              {/* <CheckboxField name="box" label="Box" /> */}
                              <CheckboxField name="cables" label="Cables" />
                              <CheckboxField
                                name="controller"
                                label="Controller"
                              />
                            </>
                          ) : productCondition?.value ===
                            PRODUCT_CONDITIONS_ENUMS.LOOSE ? (
                            <>
                              <CheckboxField name="manual" label="Manual" />
                              <CheckboxField name="cables" label="Cables" />
                              <CheckboxField
                                name="controller"
                                label="Controller"
                              />
                            </>
                          ) : (
                            ""
                          )
                        ) : [
                            ...inventoryConstants.NINTENDO_CATEGORIES,
                            ...inventoryConstants.SKYLANDER_CATEGORIES,
                          ].includes(productDataObject.consoleName) ? (
                          ""
                        ) : (
                          <CheckboxField name="manual" label="Manual" />
                        )}
                      </Col>
                    ) : (
                      ""
                    )}

                    <Col
                      md={12}
                      className="my-2 d-flex align-items-center gap-4"
                    >
                      <ProductTagList
                        setIsFirstRender={setIsFirstRender}
                        className={"align-items-center"}
                        productDetail={{
                          tags: [
                            ...productTagsList?.map((defaultTag, index) => ({
                              id: index, // Adjusting ID to ensure it doesn't overlap
                              label: defaultTag,
                              selected: selectedTags.includes(defaultTag)
                                ? true
                                : false,
                            })),
                            ...selectedTags
                              ?.filter((tag) => !productTagsList.includes(tag))
                              .map((tag, index) => ({
                                id: index + productTagsList.length,
                                label: tag,
                                selected: true,
                              })),
                          ],
                        }}
                        productCondition={productCondition}
                        tagsList={[]}
                        suggestedArrayList={productTags}
                        onSelectTagsChange={onSelectTagsChange}
                        selectedManual={{
                          isChecked: values.manual,
                          value:
                            productCondition?.value ===
                            PRODUCT_CONDITIONS_ENUMS.COMPLETE
                              ? inventoryConstants.PRODUCT_TAGS.MISSING_MANUAL
                              : productCondition?.value ===
                                PRODUCT_CONDITIONS_ENUMS.LOOSE
                              ? inventoryConstants.PRODUCT_TAGS.WITH_MANUAL
                              : "",
                        }}
                        selectedWires={{
                          isChecked: values.cables,
                          value:
                            productCondition?.value ===
                              PRODUCT_CONDITIONS_ENUMS.COMPLETE ||
                            productCondition?.value ===
                              PRODUCT_CONDITIONS_ENUMS.LOOSE
                              ? inventoryConstants.PRODUCT_TAGS.MISSING_WIRES
                              : "",
                        }}
                        selectedController={{
                          isChecked: values.controller,
                          value:
                            productCondition?.value ===
                              PRODUCT_CONDITIONS_ENUMS.COMPLETE ||
                            productCondition?.value ===
                              PRODUCT_CONDITIONS_ENUMS.LOOSE
                              ? inventoryConstants.PRODUCT_TAGS
                                  .MISSING_CONTROLLER
                              : "",
                        }}
                      />
                    </Col>
                  </Row>
                </Col>

                <Col xs={12} className="m-0 p-0 mt-4">
                  <Row className="m-0">
                    <Col md={4} className="px-0">
                      <AddEditInventoryModalPricesHistoryStats
                        productDataObject={productDataObject}
                        setProductDataObject={setProductDataObject}
                        defaultStatus={SHOPIFY_STATUS_OPTIONS[0]}
                        isShowInStoreOnlineQuantityCheck={true}
                        handleStoreAndOnlineQuantityChange={(value) => {
                          handleStoreAndOnlineQuantityChange(
                            value,
                            setFieldValue
                          );
                        }}
                        handleCustomShopifyStatusChange={
                          handleCustomShopifyStatusChange
                        }
                      />
                    </Col>
                    <Col md={8}>
                      <Row className="m-0">
                        <AddInventoryProductPrices
                          values={values}
                          productTags={productTags}
                          productType={productType}
                          selectedTags={selectedTags}
                          currentStore={currentStore}
                          setFieldValue={setFieldValue}
                          markupPresets={markupPresets}
                          marginTypeObject={marginTypeObject}
                          isInStoreQuantity={isInStoreQuantity}
                          productDataObject={productDataObject}
                          toggleIsInStoreQuantity={toggleIsInStoreQuantity}
                          priceChartingProductInfo={priceChartingProductInfo}
                          isTradeInProduct={true}
                          tradeinMargin={tradeinMargin}
                          productCondition={productCondition}
                          setMarginTypeObject={setMarginTypeObject}
                          handleMarginChange={handleMarginChange}
                          handleTradeOfferValues={handleTradeOfferValues}
                          handleCashOfferValues={handleCashOfferValues}
                          initialRatio={initialRatio}
                          productUrl={productUrl}
                        />
                        <Col md={12} className="d-flex align-items-end gap-2">
                          <Button
                            label={buttonNameConstants.CANCEL}
                            className="w-100"
                            type="button"
                            handleClick={() => handleHideModal()}
                            buttonType={buttonTypeConstants.GHOST_BUTTON}
                          />
                          <Button
                            label={
                              modalType ===
                              INVENTORY_MODAL_TYPES.ADD_FROM_NEW_TRADE_SEARCH
                                ? buttonNameConstants.ADD_TO_CART
                                : buttonNameConstants.SAVE
                            }
                            className="w-100"
                            type="submit"
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
              {productUrl && (
                <Row className="m-0 w-50">
                  <Col md={12}>
                    {productUrl && (
                      <iframe
                        title="Product Iframe"
                        src={productUrl}
                        className="iframe-website"
                      />
                    )}
                  </Col>
                </Row>
              )}
            </Modal.Body>
          </Form>
        )}
      </Formik>
      {productUrl && (
        <button
          type="button"
          onClick={() => {
            setProductUrl("");
          }}
          className="iframe-toogle-button"
        >
          <SidebarToggleIcon className={"iframe-toggle-icon"} />
        </button>
      )}
    </Modal>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  outlet: state.outlet,
  shopify: state.shopify,
  inventory: state.inventory,
  user: state.authentication.user,
  tradeDiscount: state.tradeDiscount,
  currentStore: state.store.currentStore,
  productTags: state.inventory.productTags,
  newTradeData: state.transaction.newTradeData,
  shopifySettings: state.shopify.shopifySettings,
  isAddModalOpen: state.inventory.isAddModalOpen,
  tradeinMargin: state.tradeDiscount.tradeinMargin,
  markupPresets: state.tradeDiscount.markupPresets,
  inventoryProducts: state.inventory.inventoryProducts,
  productShopifySettings: state.inventory.productShopifySettings,
  addTradeBatchInventory: state.transaction.addTradeBatchInventory,
  priceChartingProductInfo: state.inventory.priceChartingProductInfo,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  emptyPriceChartingProductObject: () =>
    dispatch(inventoryActions.emptyPriceChartingProductObject()),
  getInventoryByPricechartingId: (storeId, data) =>
    dispatch(inventoryActions.getInventoryByPricechartingId(storeId, data)),
  toggleAddModal: (value) => dispatch(inventoryActions.toggleAddModal(value)),
  activateSpinner: (data) => dispatch(systemActions.activateSpinner(data)),
  deactivateSpinner: (data) => dispatch(systemActions.deactivateSpinner(data)),
  setPriceChartingProductInfo: (data) =>
    dispatch(inventoryActions.setPriceChartingProductInfo(data)),
  setProductShopifySettings: (data) =>
    dispatch(inventoryActions.setProductShopifySettings(data)),
  getShopifyMappingsById: (storeId, id) =>
    dispatch(shopifyActions.getShopifyMappingsById(storeId, id)),
});

//-------Export AddNewUser Component
export default connect(mapStateToProps, mapDispatchToProps)(AddTrade);
